import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { NumericFormat } from 'react-number-format';
import { formatCurrency } from '@apply/ui';
import { applicationInsights } from '../../ApplicationInsights';
import { Payment, PaymentApi, RefundRequest } from '@apply/api/src/api/PaymentApi';

export interface IPaymentRefundModalParameters {
    payment: Payment | undefined;
    set_refundModalPayment: React.Dispatch<React.SetStateAction<Payment | undefined>>;
    onRefundModalRefunded: (payment: Payment) => void;
    onRefundModalClose?: () => void;
}

export const PaymentRefundModal = ({
    payment,
    set_refundModalPayment,
    onRefundModalRefunded,
    onRefundModalClose,
}: IPaymentRefundModalParameters): React.ReactElement => {
    if (payment === undefined) return <></>;

    const paymentApi = new PaymentApi(applicationInsights);

    const [refundAmount, set_refundAmount] = useState<number>(0);
    const refundAvailable = payment.amount - (payment.refunds ?? []).reduce((sum, current) => sum + current.amount, 0);

    const onRefundClick = async () => {
        const request: RefundRequest = {
            paymentId: payment.paymentId,
            amount: refundAmount,
        };

        const response = await paymentApi.refund(request);

        if (response.statusCode === 200) {
            // Close Modal
            set_refundModalPayment(undefined);
            onRefundModalRefunded(response.result);
        } else {
            // TODO display error
        }
    };

    const onCloseClick = async () => {
        set_refundModalPayment(undefined);
        onRefundModalClose && onRefundModalClose();
    };

    return (
        <div
            className='modal-dialog'
            role='document'
        >
            <Dialog
                open={true}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <div
                    className='page-header payment-modal-header'
                    role='banner'
                >
                    <h1>Refund Payment</h1>
                </div>
                <DialogContent className='payment-modal-body'>
                    <p>
                        The refundable amount is:
                        <span className='payment-modal-body-refundable-amount'>{formatCurrency(refundAvailable)}</span>
                    </p>
                    <div className='payment-modal-body-refund-amount'>
                        <p>Amount to refund:</p>
                        <NumericFormat
                            value={refundAmount}
                            placeholder={'$ 0'}
                            thousandSeparator={true}
                            prefix={'$ '}
                            onValueChange={(values) => set_refundAmount(parseInt(values.value))}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button primary'
                        onClick={onRefundClick}
                    >
                        Refund
                    </button>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button hollow'
                        onClick={onCloseClick}
                    >
                        Cancel
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
